import { PaginaCrud } from '../components/PaginaCrud'
import type { Vehiculo } from '../types'

export default function Vehiculos() {
  return (
    <PaginaCrud<Vehiculo>
      titulo="Vehiculos"
      recurso="vehiculos"
      llave="id"
      columnas={[
        { campo: 'placa', titulo: 'Placa' },
        { campo: 'marca', titulo: 'Marca', render: (v) => v.marca || '-' },
        { campo: 'modelo', titulo: 'Modelo', render: (v) => v.modelo || '-' },
        { campo: 'capacidadKg', titulo: 'Capacidad (kg)', render: (v) => (v.capacidadKg != null ? v.capacidadKg : '-') },
        { campo: 'activo', titulo: 'Activo', render: (v) => (v.activo ? 'Si' : 'No') },
      ]}
      campos={[
        { nombre: 'placa', etiqueta: 'Placa', tipo: 'texto', requerido: true },
        { nombre: 'marca', etiqueta: 'Marca', tipo: 'texto' },
        { nombre: 'modelo', etiqueta: 'Modelo', tipo: 'texto' },
        { nombre: 'capacidadKg', etiqueta: 'Capacidad (kg)', tipo: 'decimal' },
        { nombre: 'activo', etiqueta: 'Activo', tipo: 'checkbox' },
      ]}
      valorInicial={{ tenantId: 1, activo: true }}
    />
  )
}
